import {useCallback, useState} from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import {useOidcClientContext} from "../../ui/context/OidcClientContext";
import useCustomerContext from "../../customers/hooks/useCustomerContext";
import {ME_BASE_URL} from "../../../config/config";
import TransferFilters from "../types/TransferFilters";
import {TransferStatusEnum} from "../enums/TransferStatusEnum";
import ApiTransfer from "../types/ApiTransfer";

type Output = ApiTransfer[];

export function useTransferMeSearchData() {
    const {client: oidcClient} = useOidcClientContext();
    const {languageCode} = useCustomerContext();
    const client = useAPIClient(ME_BASE_URL);

    client.onError(error => {
        if (error.statusCode === 401) {
            oidcClient.login({
                locale: languageCode,
            }).then();
        } else {
            throw error;
        }
    });

    const [data, setData] = useState<Output>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback((filters: TransferFilters) => {
        setLoading(true);

        return client.get<Output>(`transfers`, {
            transferCommonDescription: filters.confirmationNo,
            event: filters.event,
            city: filters.cityId,
            direction: filters.direction,
            status: filters.status,
            itemsPerPage: 1000,
            "order[updatedAt]": "DESC",
        }).then((data) => {
            // Filtrar para excluir transfers con estado FORM_SUBMITTED
            const filteredData = data.filter(transfer =>
                transfer.status !== TransferStatusEnum.FORM_SUBMITTED
            );
            setData(filteredData);
            setLoading(false);
        }).catch(() => {
            setData([]);
            setLoading(false);
        });
    }, [client])

    return {data, loading, fetchData};
}
